"use client";

import { AlertCircle, RefreshCw } from "lucide-react";

import "@/components/templates/templates.css";

export default function TemplatesError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <main className="flex min-h-[50vh] items-center justify-center px-4">
      <div className="max-w-md rounded-xl border border-destructive/35 bg-card p-6 text-center">
        <AlertCircle className="mx-auto h-6 w-6 text-destructive" />
        <h1 className="mt-3 text-lg font-bold">Your template library did not load</h1>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">Check your connection and try again. Your saved templates have not been changed.</p>
        <button type="button" onClick={reset} className="template-primary-button mt-5"><RefreshCw className="h-4 w-4" />Try again</button>
      </div>
    </main>
  );
}
